import api from "./api";

export interface EstimateQuery {
  clientName?: string;
  name?: string;
  initialDate?: string;
  finalDate?: string;
  sortField?: string;
  sortDirection?: string;
  pageNumber?: number;
  pageSize?: number;
}

export interface Estimate {
  clientName: string;
  name: string;
  folder?: string;
  fileDate: string;
  path: string;
}

export const getEstimates = async (filter?: EstimateQuery) => {
  try {
    const response = await api.get(`/api/estimate`, { params: filter });
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const getEstimateClients = async () => {
  try {
    const response = await api.get(`/api/estimate/clients`);
    return response.data;
  } catch (error) {
    console.log("error", error);
    return [];
  }
};

export const downloadEstimate = async (path: string) => {
  try {
    const response = await api.get(`/api/estimate/download`, {
      params: { path },
    });
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};
